import React, { useState, useEffect } from "react";

import {
  Drawer,
  TextField,
  Container,
  Typography,
  Button,
  Autocomplete,
  InputAdornment,
  CircularProgress,
} from "@mui/material";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import IconButton from "@mui/material/IconButton";
import CancelIcon from "@mui/icons-material/Cancel";
import moment from "moment";
import { useSnackbar } from "notistack";
import { styled } from "@mui/material/styles";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { getTeamMembersWithoutSearchAndInActiveMembers } from "src/DAL/teamMembers";
import { Icon } from "@iconify/react/dist/iconify.js";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { get_active_companies } from "src/DAL/company";

const Root = styled("div")(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down("md")]: {
    width: 250,
  },
  [theme.breakpoints.up("md")]: {
    width: 400,
  },
  [theme.breakpoints.up("lg")]: {
    width: 450,
  },
}));
function FineFilter({
  openFilterDrawer,
  filterData,
  setFilterData,
  setOpenFilterDrawer,
  filterName,
  setFilterChipData,
  handleFilterClear,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [inputs, setInputs] = useState(null);
  const [allEmployee, setAllEmployee] = useState([]);
  const [allEmployeeLoading, setAllEmployeeLoading] = useState([]);
  const [allCompanies, setAllCompanies] = useState([]);
  const [allCompaniesLoading, setAllCompaniesLoading] = useState([]);

  const handleClose = () => {
    setOpenFilterDrawer(false);
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;

    setInputs((values) => ({ ...values, [name]: value }));
  };

  const formatEmployeeDataForChip = (data) => {
    const formatDate = (date) =>
      date && moment(date).isValid() ? moment(date).format("MMMM YYYY") : null;

    const formatted = {
      employee: data?.employee?.title
        ? `Employee: ${data.employee.title}`
        : null,
      dates:
        data?.date_from || data?.date_to
          ? `Dates: ${formatDate(data.date_from) || ""}${
              data.date_from && data.date_to ? " → " : ""
            }${formatDate(data.date_to) || ""}`
          : null,
    };

    // 🔥 remove empty/null/invalid values
    return Object.fromEntries(
      Object.entries(formatted).filter(([_, value]) => value !== null),
    );
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    setFilterData({ ...inputs });
    setFilterChipData(formatEmployeeDataForChip(inputs));
    handleClose();
  };

  const handleClearAll = () => {
    handleFilterClear();
    handleClose();
  };

  const allActiveEmp = async () => {
    setAllEmployeeLoading(true);
    try {
      const res = await getTeamMembersWithoutSearchAndInActiveMembers(
        inputs?.company?._id || "",
      );
      if (res.code === 200) {
        const allEmployee = res.employee.map((item) => {
          return {
            title: item.full_name,
            _id: item._id,
            user_id: item.user_id,
            company: item.company,
          };
        });

        setAllEmployee(allEmployee);
      } else {
        setAllEmployee([]);
        enqueueSnackbar(res.message, { variant: "error" });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setAllEmployeeLoading(false);
    }
  };

  const getCompanyList = async () => {
    setAllCompaniesLoading(true);

    const result = await get_active_companies();
    if (result.code == 200) {
      const _list = result.company.map((item) => {
        return { title: item.title, _id: item._id };
      });
      setAllCompanies(_list);
    } else {
      setAllCompanies([]);
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setAllCompaniesLoading(false);
  };

  useEffect(() => {
    if (openFilterDrawer) {
      allActiveEmp();
    }
  }, [openFilterDrawer, inputs?.company?._id]);
  useEffect(() => {
    if (openFilterDrawer) {
      getCompanyList();
    }
  }, [openFilterDrawer]);

  useEffect(() => {
    setInputs(() => ({ ...filterData }));
    setFilterChipData(formatEmployeeDataForChip({ ...filterData }));
  }, [filterData]);

  return (
    <Drawer
      variant="temporary"
      anchor="right"
      open={openFilterDrawer}
      onClose={handleClose}
    >
      <Root>
        <Container>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="mt-3 mb-4"
          >
            <Typography variant="h4">{filterName || "Filter"}</Typography>

            <IconButton
              color="error"
              onClick={handleClose}
              aria-label="handle Close"
            >
              <CancelIcon />
            </IconButton>
          </div>

          <form onSubmit={handleSubmit}>
            {/* <Autocomplete
              disablePortal
              id="combo-box-demo"
              loading={allCompaniesLoading}
              value={inputs?.company ? inputs?.company : null}
              options={allCompanies}
              getOptionLabel={(option) => option?.title}
              isOptionEqualToValue={(option, value) =>
                option?._id === value?._id
              }
              onChange={(e, v) => {
                handleChange({
                  target: { name: "company", value: v ? v : "" },
                });
                if (v?._id && inputs?.employee?.company?._id !== v?._id) {
                  handleChange({
                    target: { name: "employee", value: "" },
                  });
                }
              }}
              sx={{ width: "100%", marginBottom: 2 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Company"
                  placeholder="Search company..."
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {allCompaniesLoading && <CircularProgress size={20} />}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon icon={"iconamoon:search-bold"} />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            /> */}
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              loading={allEmployeeLoading}
              value={inputs?.employee ? inputs?.employee : null}
              options={allEmployee}
              getOptionLabel={(option) => option?.title}
              isOptionEqualToValue={(option, value) =>
                option?._id === value?._id
              }
              onChange={(e, v) =>
                handleChange({
                  target: { name: "employee", value: v ? v : "" },
                })
              }
              sx={{ width: "100%", marginBottom: 2 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Employee"
                  placeholder="Search..."
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {allEmployeeLoading && <CircularProgress size={20} />}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon icon={"iconamoon:search-bold"} />
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />

            <Typography variant="subtitle1" gutterBottom className="pb-2">
              Dates:
            </Typography>

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                views={["year", "month"]}
                openTo="month"
                label="Start Month"
                className="mb-3"
                value={inputs?.date_from || null}
                onChange={(value) => {
                  setInputs((prev) => {
                    const updated = {
                      ...prev,
                      date_from: value,
                    };

                    // if from_date > to_date → update to_date
                    if (prev?.date_to && value > prev.date_to) {
                      updated.date_to = value;
                    }

                    return updated;
                  });
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                views={["year", "month"]}
                openTo="month"
                label="End Month"
                className="mb-3"
                value={inputs?.date_to || null}
                onChange={(newValue) => {
                  setInputs((prev) => ({
                    ...prev,
                    date_to: newValue,
                  }));
                }}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </LocalizationProvider>

            <Button
              sx={{
                float: "right",
                width: { xs: "100%", md: "auto" },
                marginBottom: { xs: "10px" },
              }}
              variant="contained"
              type="submit"
              endIcon={<FilterAltIcon />}
            >
              Filter
            </Button>
            <Button
              sx={{
                marginRight: { xs: 0, md: 2 },
                float: "right",
                width: { xs: "100%", md: "auto" },
              }}
              variant="contained"
              onClick={handleClearAll}
              endIcon={<ClearAllIcon />}
            >
              Reset Filter
            </Button>
          </form>
        </Container>
      </Root>
    </Drawer>
  );
}

export default FineFilter;
